Preloader = require "lib/preload"
SlideView = require("views/slide")
device     = require("lib/device")
videojs = require("video.js").default

class VideoCollectionView extends SlideView
  template: require("./template")

  events: ->
    "iostap .btn-done":   "submit"
    "iostap .exit-video": "exitVideo"
    "iostap .tappy":      "onTapThumbnail"

  serialize: ->
    data = super

    data.isShort = _.chain(data.videos)
      .pluck("title")
      .map (title) => title or ""
      .sortBy("length")
      .last()
      .value()
      .length < 20

    data.videos = _.filter(data.videos or [], (d) -> d.url)
    data.hasPrompt = true
    data

  onResize: ->
    length = @getEl("tappies").children.length
    height = @getEl("parent").firstChild.offsetHeight - @getEl("title").offsetHeight

    if length >= 4
      tappyHeight = (height * (1 + length / 10)) / length
    else
      tappyHeight = height / length

    for el, i in @getEl("tappies").children
      el.style.height = "#{tappyHeight}px"

  onRefresh: ->
    @beforeShow()
    @show()

  beforeShow: ->
    @setEl @findOne(".tappies-parent"), "parent"
    @setEl @findOne(".tappies"), "tappies"
    @setEl @findOne(".title"), "title"
    @setEl @findAll(".video-details"), "videoDetails"

    @videos = []
    for video in @findAll("video")
      player = videojs(video)
      @videos.push player
      onExit = => window.setTimeout (=> @exitVideo()), 300
      do (player) =>
        player.on "fullscreenchange", =>
          onExit() unless player.isFullscreen()
        
    if device.platform != "browser"
      Application.publish("event:rotation-unlock") {}
    
    @onResize()

  show: ->
    @listenTo this, "resize", @onResize
    @toVisit = [0...@serialize().videos.length]

  onTapThumbnail: (e) ->
    @openVideo e.currentTarget, true

  openVideo: (el, animate) ->
    @currentIndex = parseInt(el.dataset.index, 10)
    vidDetails    = @getEl("videoDetails").item(@currentIndex)
    @toVisit      = _.without @toVisit, @currentIndex

    @setState("touched") if _.isEmpty(@toVisit)
    @setState(true, "video")

    @trigger("ui", lightbox: true)

    player = @videos[@currentIndex]

    player.ready =>
      player.currentTime 0
      player.play()

    if (el.classList?)
      el.classList.add("visited")
      vidDetails.classList.toggle("no-transition", not animate)
      vidDetails.classList.add("active")
  
  beforeHide: ->
    if device.platform != "browser"
      Application.publish("event:rotation-lock") {}
  
  hide: ->
    @exitVideo()
    super(arguments...)

  exitVideo: ->
    vidDetails = @getEl("videoDetails").item(@currentIndex)
    if (vidDetails?)
      vidDetails.classList.remove("no-transition")
      vidDetails.classList.remove("active")
    @trigger("ui", lightbox: false)
    @setState(false, "video")
    @videos[@currentIndex]?.pause()

  refresh: (params) ->
    if @currentIndex?
      @exitVideo()

    super

module.exports = VideoCollectionView
